import { render, staticRenderFns } from "./GridWorkType.vue?vue&type=template&id=31d54a5e&"
import script from "./GridWorkType.vue?vue&type=script&lang=js&"
export * from "./GridWorkType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports